import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService
} from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { WorkOrderService } from "../../../services/workorder.service";
declare var google;

@Component({
  selector: "approved-Wo",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "approvedWoReport.html"
})
export class approvedWoReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input("menu") menu: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  gridOptions: any;
  seasonList = [];
  season = "";
  dataList = [];
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  styleList = ["Formal", "Casual", "Clubwear", "Core", "Gang"];

  filter = {
    groupby: "WO NO",
    shirtdno: "",
    from_date: "",
    to_date: "",
    party_code: "",
    season: "",
    season_id: "",
    wo_no: "",
    width: [],
    brand: [],
    style: [],
    fin_id: "",
    finyear: "2020-2021",
    approved: "Approved"
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc"
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: []
  };

  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  approvedList = ["Approved", "Pending", "All"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private poservice: PurchaseOrderService,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private woservice: WorkOrderService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.widthlist();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    if (this.menu.param == "sampleVsWo") {
      this.getSampleVsWo();
    } else {
      this.getOrderList();
    }
  }

  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }

  onCellClick(event) {
    this.filter.groupby = "DESIGN SHADE";
    let row = event.row;
    let params = {
      wo_no: row.wo_no
    };
    let that = this;

    this.isLoadMask = this.woservice
      .getDesignList(params)
      .then(function(res: any) {
        row = res.data;
        that.orderList = res.data;
        let tabObj = {};
        let mode = "View";
        tabObj = {
          action: "NewTab",
          params: {
            //   tabParent: 'Transaction',
            tabName: "VIEW WORK ORDER",
            title: "VIEW WORK ORDER",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "VIEW WORK ORDER"
          }
        };

        that.tabUpdateEvent.emit(tabObj);
      });
  }

  applyFilter(season, finyear, status): void {
    if (finyear) {
      let parFinyear = _.filter(this.finyearList, { finyear: finyear });
      this.filter.fin_id = parFinyear[0].fin_id;
      this.getSeasonList(season);
      if (season) {
        let parSeason = _.filter(this.seasonList, { season: season });
        this.filter.season_id = parSeason[0].season_id;
        this.filter.season = parSeason[0].season;
      }
    }
  }

  woFilter(wo_no) {
    this.filter.wo_no = wo_no;
    this.filter.groupby = "";
    this.filter.style = [];
    this.filter.from_date = "";
    this.filter.to_date = "";
    this.filter.party_code = "";
    this.getOrderList();
    this.filter.wo_no = "";
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.fin_id = res.data[0].fin_id;
      that.filter.finyear = res.data[0].finyear;
      that.getSeasonList("");
    });
  }
  getSeasonList(season) {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
      fin_id: this.filter.fin_id
    };
    let that = this;
    that.purReport.getSeason(params).then((res: any) => {
      that.seasonList = res;
      let curDate = new Date();
      var now =
        curDate.getFullYear() +
        "-" +
        0 +
        Number(curDate.getMonth() + 1) +
        "-" +
        curDate.getDate();
      that.seasonList.forEach(el => {
        if (now > el.rd_from && now < el.rd_to) {
          that.filter.season = el.season;
          that.filter.season_id = el.season_id;
        }
      });

      if (season) {
        let parSeason = _.filter(this.seasonList, { season: season });
        that.filter.season_id = parSeason[0].season_id;
        that.filter.season = parSeason[0].season;
      }
      if (this.menu.param == "sampleVsWo") {
        this.getSampleVsWo();
      } else {
        this.getOrderList();
      }
    });
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter)
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: []
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getApprovedWOReport(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false
        };

        that.exceldata = that.getData(res.columns, res.data);
      });
  }
  getSampleVsWo(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter)
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: []
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getSampleVsWo(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false
        };

        that.exceldata = that.getData(res.columns, res.data);
      });
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/approvedWoReport.ts